import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ee_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const auth = {
  login: async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ee_token", data.access_token);
    localStorage.setItem("ee_email", data.email);
    return data;
  },
  logout: () => {
    localStorage.removeItem("ee_token");
    localStorage.removeItem("ee_email");
  },
  isAuthed: () => Boolean(localStorage.getItem("ee_token")),
  email: () => localStorage.getItem("ee_email"),
};
